var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M20 7h66c5.51915024 0 10 4.48084976 10 10v66c0 5.51915024-4.48084976 10-10 10H20c-5.51915024 0-10-4.48084976-10-10V17c0-5.51915024 4.48084976-10 10-10z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8,
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 9.036
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.12 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "rgb(140,121,174)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M69.47454834 28H36.52307129C32.92034912 28 30 30.9284668 30 34.54101563v24.19970703c0 3.61230468 2.92034912 6.53979492 6.52307129 6.53979492h10.11865234L52.99969483 72l6.35858154-6.71948242h10.11627197C73.07849121 65.28051758 76 62.35302734 76 58.74072266V34.54101562C76 30.9284668 73.07788086 28 69.47454834 28zm-7.95288086 22.44458008l1.90179443-1.91357422c2.50616455-2.9074707 2.38812256-7.30322266-.36474609-10.06274414-2.76000977-2.76635742-7.15838623-2.87817383-10.059021-.34887695-2.90124511-2.52929688-7.29907226-2.41748047-10.05847168.34887695-2.753479 2.75952148-2.87145996 7.15527344-.36590576 10.06274414l10.42437744 10.48876953 2.255188-2.26953125h-1.06323243c-1.3147583 0-2.38391113-1.07250976-2.38391113-2.38964844v-1.49365234c0-1.31713867 1.06915283-2.38964844 2.38391113-2.38964844h1.07220459V49.4025879c0-1.31713867 1.06915283-2.38964844 2.38391113-2.38964844h1.48999024c1.3147583 0 2.38391113 1.07250977 2.38391113 2.38964844v1.04199219zm2.26361084 3.91577148c0 .65966797-.53399658 1.19482422-1.1920166 1.19482422h-2.2635498v2.26953125c0 .65966797-.53399659 1.19482422-1.19195557 1.19482422H57.6477661c-.65795898 0-1.19195556-.53515625-1.19195556-1.19482422v-2.26953125h-2.26416016c-.65795898 0-1.19195557-.53515625-1.19195557-1.19482422v-1.4934082c0-.66015625.53399659-1.19482422 1.19195557-1.19482422h2.26416016V49.4025879c0-.65966797.53399658-1.19482422 1.19195556-1.19482422h1.48999024c.65795898 0 1.19195556.53515625 1.19195556 1.19482422v2.26953125h2.2635498c.65802003 0 1.19201661.53466797 1.19201661 1.19482422v1.4934082z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.972a92528c28151f49cbbf2365a22697.svg";
export { ForwardRef as ReactComponent };